<template>
  <div>
    <BaseHeader title="ValidationExample" />
    <el-checkbox v-model="popover">エラーメッセージをpopoverする</el-checkbox>

    <!-- =============================================================== -->
    <!-- Input -->
    <!-- =============================================================== -->
    <hr style="margin: 10px 0;">
    <h2>Input</h2>

    <span>■通常使用</span>
    <BaseValidInput
        v-model="input1"
        v-validate="'required'"
        :error-msg="errors.first('input1Valid')"
        :popover-error-msg="popover"
        name="input1Valid"
        data-vv-as="入力" />

    <p style="margin: 5px 0;">■el-row/el-colの中に入れるとValidationが効かない</p>
    <p style="margin: 5px 0;">※BaseValid**が孫以降のコンポーネントになった状態</p>
    <el-row :gutter="15">
      <el-col :span="12">
        <BaseValidInput
            v-model="input2"
            v-validate="'required'"
            :error-msg="errors.first('input2Valid')"
            :popover-error-msg="popover"
            name="input2Valid"
            data-vv-as="入力" />
      </el-col>
      <el-col :span="12">
        <BaseValidInput
            v-model="input3"
            v-validate="'required'"
            :error-msg="errors.first('input3Valid')"
            :popover-error-msg="popover"
            name="input3Valid"
            data-vv-as="入力" />
      </el-col>
    </el-row>

    <p style="margin: 5px 0;">class/styleでel-col/el-rowは再現可能なのでclass/styleで対応</p>
    <div class="el-row"
        style="margin-left: -7.5px; margin-right: -7.5px;">
      <div class="el-col el-col-12"
          style="padding-left: 7.5px; padding-right: 7.5px;">
        <BaseValidInput
            v-model="input4"
            v-validate="'required'"
            :error-msg="errors.first('input4Valid')"
            :popover-error-msg="popover"
            name="input4Valid"
            data-vv-as="入力" />
      </div>
      <div class="el-col el-col-12"
          style="padding-left: 7.5px; padding-right: 7.5px;">
        <BaseValidInput
            v-model="input5"
            v-validate="'required'"
            :error-msg="errors.first('input5Valid')"
            :popover-error-msg="popover"
            name="input5Valid"
            data-vv-as="入力" />
      </div>
    </div>
    <p style="margin: 5px 0;">子のコンポーネントを修正できるならprovide/injectで対応</p>
    <p style="margin: 5px 0;">※OrderDetail/BaseTableDetail参照</p>

    <p style="margin: 5px 0;">■el-inputと同様の属性指定可能</p>
    <BaseValidInput
        v-model="input6"
        v-validate="'required'"
        :error-msg="errors.first('input6Valid')"
        :popover-error-msg="popover"
        name="input6Valid"
        data-vv-as="入力"
        placeholder="入力項目"
        suffix-icon="el-icon-message"
        prefix-icon="el-icon-star-on"
        clearable>
      <template slot="prepend">Http://</template>
      <template slot="append">.com</template>
    </BaseValidInput>

    <p style="margin: 5px 0;">■textareaはtype='textarea'で</p>
    <BaseValidInput
        v-model="input7"
        v-validate="'required'"
        :error-msg="errors.first('input7Valid')"
        :popover-error-msg="popover"
        :rows="5"
        name="input7Valid"
        data-vv-as="入力"
        type="textarea" />

    <!-- =============================================================== -->
    <!-- Number -->
    <!-- =============================================================== -->
    <hr style="margin: 10px 0;">
    <h2>Number</h2>

    <p style="margin: 5px 0;">■el-input-numberのValidation</p>
    <BaseValidNumber
        v-model="val1"
        v-validate="'required|max_value:10'"
        :error-msg="errors.first('val1Valid')"
        :popover-error-msg="popover"
        :step="5"
        name="val1Valid"
        data-vv-as="数値" />
    <p style="margin: 5px 0;">■少数点などもel-input-numberと同様に扱える</p>
    <BaseValidNumber
        v-model="val2"
        v-validate="'required|max_value:5.5'"
        :error-msg="errors.first('val2Valid')"
        :popover-error-msg="popover"
        :precision="2"
        :step="0.1"
        :max="10"
        name="val2Valid"
        data-vv-as="数値" />
    <p style="margin: 5px 0;">■ボタンの位置なども同様に変更</p>
    <BaseValidNumber
        v-model="val3"
        v-validate="'required|min_value:10'"
        :error-msg="errors.first('val3Valid')"
        :popover-error-msg="popover"
        name="val3Valid"
        data-vv-as="数値"
        controls-position="right" />

    <!-- =============================================================== -->
    <!-- Radio -->
    <!-- =============================================================== -->
    <hr style="margin: 10px 0;">
    <h2>Radio</h2>

    <p style="margin: 5px 0;">■ラジオボタン</p>
    <BaseValidRadio
        v-model="radio1"
        v-validate="'required|included:val1,val3'"
        :radio-list="radioOption"
        :error-msg="errors.first('radio1Valid')"
        :popover-error-msg="popover"
        name="radio1Valid"
        data-vv-as="項目" />

    <p style="margin: 5px 0;">■ボタン形式</p>
    <BaseValidRadio
        v-model="radio2"
        v-validate="'required|included:val1,val2'"
        :radio-list="radioOption"
        :error-msg="errors.first('radio2Valid')"
        :popover-error-msg="popover"
        name="radio2Valid"
        data-vv-as="項目"
        size="mini"
        button />

    <p style="margin: 5px 0;">■ボーダー形式</p>
    <p style="margin: 5px 0;">※option毎にborder: true設定が必要</p>
    <BaseValidRadio
        v-model="radio3"
        v-validate="'required|included:val2,val3'"
        :radio-list="radio3Option"
        :error-msg="errors.first('radio3Valid')"
        :popover-error-msg="popover"
        name="radio3Valid"
        data-vv-as="項目"
        options-label-key="codeTest"
        options-view-label-key="nameTest"
        options-disabled-key="disabledTest"
        options-border-key="borderTest"
        options-size-key="sizeTest"
        size="mini" />

    <!-- =============================================================== -->
    <!-- CheckBox -->
    <!-- =============================================================== -->
    <hr style="margin: 10px 0;">
    <h2>CheckBox</h2>

    <p style="margin: 5px 0;">■チェックボックス</p>
    <p style="margin: 5px 0;">※Indeterminateには非対応</p>
    <BaseValidCheckbox
        v-model="checklist1"
        v-validate="'required|included:val1,val3'"
        :check-list="checklistOption"
        :error-msg="errors.first('checklist1Valid')"
        :popover-error-msg="popover"
        name="checklist1Valid"
        data-vv-as="項目" />

    <p style="margin: 5px 0;">■ボタン形式</p>
    <BaseValidCheckbox
        v-model="checklist2"
        v-validate="'required|included:val2,val3'"
        :check-list="checklistOption2"
        :error-msg="errors.first('checklist2Valid')"
        :popover-error-msg="popover"
        name="checklist2Valid"
        data-vv-as="項目"
        options-label-key="codeTest"
        options-view-label-key="nameTest"
        options-disabled-key="disabledTest"
        options-border-key="borderTest"
        options-size-key="sizeTest"
        size="mini"
        button />

    <!-- =============================================================== -->
    <!-- Select -->
    <!-- =============================================================== -->
    <hr style="margin: 10px 0;">
    <h2>Select</h2>

    <p style="margin: 5px 0;">■セレクトボックス</p>
    <BaseValidSelect
        v-model="select1"
        v-validate="'required|included:100,200'"
        :options="selectOption"
        :error-msg="errors.first('select1Valid')"
        :popover-error-msg="popover"
        name="select1Valid"
        data-vv-as="項目"
        clearable />

    <p style="margin: 5px 0;">■複数選択可能</p>
    <p style="margin: 5px 0;">※×ボタン押下により削除すると他のエラーメッセージが削除される --未調査</p>
    <BaseValidSelect
        v-model="select2"
        v-validate="'required|included:200,300'"
        :options="selectOption2"
        :error-msg="errors.first('select2Valid')"
        :popover-error-msg="popover"
        name="select2Valid"
        data-vv-as="項目"
        options-value-key="codeTest"
        options-label-key="nameTest"
        multiple />

    <p style="margin: 5px 0;">■カスタムテンプレート利用可能</p>
    <p style="margin: 5px 0;">※slot-scopeの指定により子コンポーネント内での値をバインディング</p>
    <BaseValidSelect
        v-model="select3"
        v-validate="'required'"
        :options="selectOption"
        :error-msg="errors.first('select3Valid')"
        :popover-error-msg="popover"
        name="select3Valid"
        data-vv-as="項目">
      <template slot-scope="custom">
        <span style="float: left">{{ custom.item.code }}</span>
        <span style="float: right; color: #8492a6; font-size: 13px">{{ custom.item.name }}</span>
      </template>
    </BaseValidSelect>

    <fieldset>
      <legend>動的SelectOptions</legend>
      <BaseValidSelect
          v-model="selectGroup1"
          :options="selectGroupOption"
          name="selectGroup1"
          data-vv-as="項目"
          clearable />
      <BaseValidSelect
          v-model="selectGroup2"
          :options="filteredSelectGroupOption2"
          name="selectGroup2"
          data-vv-as="項目"
          clearable />
    </fieldset>

    <!-- =============================================================== -->
    <!-- カスタムルール -->
    <!-- =============================================================== -->
    <hr style="margin: 10px 0;">
    <h2>カスタムルール</h2>
    <BaseTableDetail
        :border="true"
        :table-set-list="tableSetList1"
        :display-item="settingData1"
        :editable="editable" />

    <BaseTableDetail
        :border="true"
        :table-set-list="tableSetList2"
        :display-item="settingData2"
        :editable="editable" />

    <el-input
        v-model="input8"
        name="input8Valid"
        data-vv-as="入力" />
    <el-input
        v-model="input9"
        v-validate="{'testValidator2': input8}"
        name="input9Valid" />
    <div v-show="errors.has('input9Valid')"
        class="is-error-msg">
      {{ errors.first('input9Valid') }}
    </div>
    <hr style="margin: 10px 0;">

    <el-button @click="validateForm">登録</el-button>
  </div>
</template>

<script>
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

import BaseHeader from '@/components/molecules/BaseHeader'
import BaseValidInput from '@/components/atoms/BaseValidInput'
import BaseValidNumber from '@/components/atoms/BaseValidNumber'
import BaseValidRadio from '@/components/atoms/BaseValidRadio'
import BaseValidCheckbox from '@/components/atoms/BaseValidCheckbox'
import BaseValidSelect from '@/components/atoms/BaseValidSelect'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'

export default {
  name: 'ValidationExample',
  components: {
    BaseHeader,
    BaseValidInput,
    BaseValidNumber,
    BaseValidRadio,
    BaseValidCheckbox,
    BaseValidSelect,
    BaseTableDetail
  },
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      popover: false,
      input1: '',
      input2: '',
      input3: '',
      input4: '',
      input5: '',
      input6: '',
      input7: '',
      input8: '',
      input9: '',
      val1: null,
      val2: 1.0,
      val3: null,
      radio1: null,
      radio2: null,
      radio3: null,
      radioOption: [
        { code: 'val1', name: 'val1', disabled: true },
        { code: 'val2', name: 'val2' },
        { code: 'val3', name: 'val3' }
      ],
      radio3Option: [
        { codeTest: 'val1', nameTest: 'val1', borderTest: true },
        { codeTest: 'val2', nameTest: 'val2', borderTest: true, sizeTest: 'mini', disabledTest: false },
        { codeTest: 'val3', nameTest: 'val3', borderTest: true }
      ],
      checklist1: [],
      checklist2: [],
      checklistOption: [
        { code: 'val1', name: '項目１' },
        { code: 'val2', name: '項目２' },
        { code: 'val3', name: '項目３' }
      ],
      checklistOption2: [
        { codeTest: 'val1', nameTest: '項目１' },
        { codeTest: 'val2', nameTest: '項目２', sizeTest: 'mini', disabledTest: true },
        { codeTest: 'val3', nameTest: '項目３' }
      ],
      select1: ['300'],
      select2: [],
      select3: [],
      selectOption: [
        { code: '100', name: '項目１' },
        { code: '200', name: '項目２' },
        { code: '300', name: '項目３' }
      ],
      selectOption2: [
        { codeTest: '100', nameTest: '項目１' },
        { codeTest: '200', nameTest: '項目２' },
        { codeTest: '300', nameTest: '項目３' }
      ],
      selectGroup1: null,
      selectGroup2: null,
      selectGroupOption: [
        { code: 1, name: 'グループ１' },
        { code: 2, name: 'グループ２' },
        { code: 3, name: 'グループ３' }
      ],
      selectGroupOption2: [
        { code: 11, name: 'グループ１－１', group: 1 },
        { code: 12, name: 'グループ１－２', group: 1 },
        { code: 13, name: 'グループ１－３', group: 1 },
        { code: 21, name: 'グループ２－１', group: 2 },
        { code: 22, name: 'グループ２－２', group: 2 },
        { code: 31, name: 'グループ３－１', group: 3 },
        { code: 32, name: 'グループ３－２', group: 3 },
        { code: 33, name: 'グループ３－３', group: 3 },
        { code: 34, name: 'グループ３－４', group: 3 }
      ],
      editable: {
        readonly: false,
        editable: true
      },
      tableSetList1: [
        {
          label: '丸め方法１',
          properties: [
            { path: 'roundType1', type: 'String', editableId: 'editable',
              codeName: 'm_point_base_config.round_type', selectCode: 'm_point_base_config.round_type',
              elementType: ELEMENT_TYPE.SELECT_BOX }
          ]
        }, {
          label: '丸め方法２',
          properties: [
            { path: 'roundType2', type: 'String', editableId: 'editable',
              codeName: 'm_point_base_config.round_type', selectCode: 'm_point_base_config.round_type',
              elementType: ELEMENT_TYPE.SELECT_BOX }
          ]
        }, {
          label: 'メッセージ',
          properties: [
            { path: 'message', type: 'String', editableId: 'readonly',
              elementType: ELEMENT_TYPE.INPUT }
          ]
        }
      ],
      settingData1: {
        roundType1: null,
        roundType2: null,
        message: null
      },
      tableSetList2: [
        {
          label: 'テキスト1',
          properties: [
            { path: 'text1', type: 'String', editableId: 'editable', validateRule: 'required',
              elementType: ELEMENT_TYPE.INPUT }
          ]
        }, {
          label: 'テキスト2',
          properties: [
            { path: 'text2', type: 'String', editableId: 'editable', validateAs: 'テキスト2', validateRule: () => { return { 'testValidator2': this.settingData2.text1 } },
              elementType: ELEMENT_TYPE.INPUT }
          ]
        }
      ],
      settingData2: {
        text1: '',
        text2: ''
      }
    }
  },
  computed: {
    validateTarget () {
      return {
        roundType1: this.settingData1.roundType1,
        roundType2: this.settingData1.roundType2
      }
    },
    filteredSelectGroupOption2 () {
      return this.selectGroupOption2.filter((option, index) => this.selectGroup1 && option.group === this.selectGroup1)
    }
  },
  watch: {
    validateTarget (value) {
      this.$log.debug('watch')
      this.$validator.validate('validateTarget', value).then(result => {
        if (!result && this.errors.has('validateTarget')) {
          this.settingData1.message = this.errors.first('validateTarget')
        } else {
          this.settingData1.message = ''
        }
      })
    }
  },
  beforeCreate () {
  },
  created () {
    this.$validator.extend('testValidator', {
      getMessage (field, args) {
        return '丸め方法１と丸め方法２が同じです'
      },
      validate (value, args) {
        this.$log.debug('validate:', value, args)
        return value.roundType1 !== value.roundType2
      }
    })
    this.$validator.attach({
      name: 'validateTarget',
      rules: 'testValidator'
    })
    this.$validator.extend(
      'testValidator2',
      {
        getMessage (field, args) {
          this.$log.debug('testValidator2[getMessage]:', field, args)
          return field + 'のエラーメッセージ'
        },
        validate (value, args) {
          this.$log.debug('testValidator2[validate]:', value, args)
          return value !== args[0]
        }
      })
  },
  beforeMount () {
  },
  mounted () {
  },
  methods: {
    validateForm () {
      this.$log.error('!! error !!', this)
      this.$log.warn('!! warn !!')
      this.$log.info('!! info !!')
      this.$log.debug('!! debug !!')
      this.$validator.validate().then(result => {
        if (result) {
          this.$log.debug('All is well')
          return
        }
        this.$log.debug(this)
      })
    }
  }
}
</script>
